import React, { useEffect, useMemo, useState } from "react";
import { View, Pressable, } from "react-native";
import { appColors } from "../../themes/appTheme";
import { ThemeConsumer } from "@rneui/themed";
import { useIsFocused } from "@react-navigation/native";
import { commonDialogBoxStyle } from "../../themes/shared/commonComponents/commonDialogBoxStyle";
import {
    DialogType,
    DefaultFieldType,
    FieldType,
    Constant
} from "./commonDialogBoxModule";
import { ZenText } from "zen-core-elements";


interface DialogBoxProp {
    type?: DialogType
    confirmation: (arg1: any) => void;
    updation?: boolean
}

const CommonDialogBox = (props: DialogBoxProp & (DefaultFieldType | FieldType)) => {

    const isFocus = useIsFocused()

    const [confirmationData, setConfirmationData] = useState({ dialog: { content: '', button: [{ id: 0, name: '' }] } })

    const [replace, setReplace] = useState(props.replaceValue || '')

    const chooseButton = (button: DialogType) => {
        let selectButton: { id: number; name: string }[] = [];

        switch (button) {
            case 'DELETE':
                selectButton = Constant.DELETE.button;
                break;
            case 'EDIT':
                selectButton = Constant.EDIT.button;
                break;
            case 'BULKDELETE':
                selectButton = Constant.BULKDELETE.button;
                break;
            case 'LOGOUT':
                selectButton = Constant.LOGOUT.button;
                break;
            default:
                selectButton = Constant.DISABLE.button;
                break;
        }
        return selectButton;
    };

    const chooseContent = (content: DialogType) => {
        let msg = '';

        switch (content) {
            case 'DELETE':
                msg = Constant.DELETE.content;
                break;
            case 'EDIT':
                msg = Constant.EDIT.content;
                break;
            case 'BULKDELETE':
                msg = Constant.BULKDELETE.content;
                break;
            case 'LOGOUT':
                msg = Constant.LOGOUT.content;
                break;
            default:
                msg = Constant.DISABLE.content;
                break;
        }

        return msg;
    };

    useEffect(() => {
        if (isFocus) {

            if (props?.type != 'OTHER') {
                setConfirmationData((prev) => {
                    let confirmation = { ...prev }
                    confirmation.dialog.content = (props?.replaceValue && props.replaceValue != 'clockout') ? chooseContent(props.type).replace('item', props?.replaceValue) : props?.replaceValue == 'clockout' ? chooseContent(props.type).replace('logout', props?.replaceValue) : chooseContent(props.type)
                    confirmation.dialog.button = chooseButton(props.type)
                    return confirmation
                })
            }
            else if (props.dialog != null) {
                setConfirmationData((prev) => {
                    let confirmation = { ...prev }
                    confirmation.dialog.content = props?.dialog?.content ? props?.dialog?.content : ''
                    confirmation.dialog.button = props?.dialog?.button ? props?.dialog?.button : []
                    return confirmation
                })
            }
        }
    }, [isFocus])





    return (
        <ThemeConsumer>
            {({ theme }: any) => (
                <View style={commonDialogBoxStyle.conatiner}>
                    <View style={commonDialogBoxStyle.wrapper}>
                        <ZenText content="confirmation" bold size={'medium'} color={appColors.dark} style={{ textTransform: 'capitalize' }} />
                    </View>
                    <View style={commonDialogBoxStyle.contentTxt}>
                        <ZenText ellipsizeMode="tail" content={confirmationData.dialog.content} color={appColors.dark} bold size={'medium'} style={[{ textAlign: 'left', width: '80%' }]} />
                        <View style={{ flexDirection: "row-reverse", justifyContent: "space-between", alignSelf: confirmationData?.dialog?.button.length >= 2 ? 'flex-end' : 'center', marginVertical: 10 }}>
                            {
                                confirmationData?.dialog?.button.map((i, ind) =>
                                (
                                    <Pressable key={ind}
                                        style={{
                                            justifyContent: 'space-between',
                                            backgroundColor: appColors.light,
                                            alignItems: 'center',
                                            paddingVertical: 5,
                                            borderRadius: 10,
                                            borderWidth: ind + 1 == 2 ? 0 : 1.5,
                                            borderColor: ind + 1 == 2 ? appColors.light : appColors.lightGrey,
                                            paddingHorizontal: 20,
                                        }}
                                        onPress={() => {
                                            props.confirmation(i)
                                        }} >
                                        <ZenText size={'medium'} bold content={i.name} color={ind + 1 == 2 ? appColors.mildBlack : '#800000'} style={{ textTransform: 'capitalize', paddingHorizontal: 10, textAlign: 'center', }} />
                                    </Pressable>
                                ))
                            }
                        </View>
                    </View>


                </View>
            )}
        </ThemeConsumer>

    )
}

export default CommonDialogBox

